import { useState, useEffect } from 'react';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var mediaQueries = {
  phone: '(min-width: 320px) and (max-width: 568px)',
  tablet: '(min-width : 768px) and (max-width : 1024px)',
  desktop: '(min-width : 1224px)'
};

var index = function index(query) {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') return;
  if (!window.matchMedia) return;
  var queryToMatch = mediaQueries[query] || query;

  var _useState = useState(window.matchMedia(queryToMatch).matches),
      _useState2 = _slicedToArray(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];

  useEffect(function () {
    var media = window.matchMedia(queryToMatch);
    if (media.matches !== matches) setMatches(media.matches);

    var listener = function listener() {
      return setMatches(media.matches);
    };

    media.addEventListener("change", listener);
    return function () {
      return media.removeEventListener("change", listener);
    };
  }, [matches, queryToMatch]);
  return matches;
};

export default index;